import { Controller } from "@hotwired/stimulus"

// Controls collapsible sections inside the sidebar navigation
export default class extends Controller {
  static targets = ["toggle", "submenu"]
  static values = { key: { type: String, default: "sidebar-groups" } }

  connect() {
    this.state = this.loadState()
    let stateChanged = false

    this.toggleTargets.forEach((toggle, index) => {
      const submenu = this.submenuTargets[index]
      const groupId = this.groupId(toggle, index)
      const initiallyOpen = this.state[groupId] === true
      this.setState(toggle, submenu, initiallyOpen)
      if (submenu?.querySelector(".active") && !initiallyOpen) {
        this.setState(toggle, submenu, true)
        this.state[groupId] = true
        stateChanged = true
      }
    })

    if (stateChanged) this.saveState()
  }

  toggle(event) {
    const toggle = event.currentTarget
    const index = this.toggleTargets.indexOf(toggle)
    const submenu = this.submenuTargets[index]
    const willOpen = !toggle.classList.contains("is-open")
    const groupId = this.groupId(toggle, index)
    this.setState(toggle, submenu, willOpen)
    this.state[groupId] = willOpen
    this.saveState()
  }

  setState(toggle, submenu, shouldOpen) {
    if (!submenu) return

    toggle.setAttribute("aria-expanded", shouldOpen)
    toggle.classList.toggle("is-open", shouldOpen)
    submenu.classList.toggle("is-open", shouldOpen)
  }

  groupId(toggle, index) {
    return toggle.dataset.groupId || `group-${index}`
  }

  loadState() {
    try {
      const stored = window.localStorage.getItem(this.keyValue)
      return stored ? JSON.parse(stored) : {}
    } catch (error) {
      console.warn("No se pudo cargar el estado del menú", error)
      return {}
    }
  }

  saveState() {
    try {
      window.localStorage.setItem(this.keyValue, JSON.stringify(this.state))
    } catch (error) {
      console.warn("No se pudo guardar el estado del menú", error)
    }
  }
}
